import React from 'react';

import { Container, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import useStyles from './styles';

const Maintenance = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Container className={classes.wrapper}>
      <img
        className={classes.img}
        height="70px"
        src="https://img-cdn.financeunlocked.com/logos/all-logos2.png?updatedAt=1635731447225"
        alt="logo"
      />
      <Typography className={classes.title}>{t('page.maintenance.wellBeBackSoon')}</Typography>
      <Typography className={classes.text}>
        <Trans i18nKey="page.maintenance.sorryForTheInconvenience">
          Sorry for the inconvenience but we’re performing some maintenance at the moment. If you
          need to you can always
          <a className={classes.link} href="mailto:support@financeunlocked.com">
            contact us by email
          </a>
          , otherwise we’ll be back online shortly!
        </Trans>
      </Typography>
      <Typography className={classes.text}>— {t('page.maintenance.theUnlockedTeam')}</Typography>
    </Container>
  );
};

export default Maintenance;
